import { render } from "./pointTable.vue?vue&type=template&id=d9500a2a"
import script from "./pointTable.vue?vue&type=script&lang=js"
export * from "./pointTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__